import React from 'react';

function BeautifulScreen(props) {
    return(
        <div>
            {props.calcP || 0}
        </div>
         );
}
export default BeautifulScreen;